import Highlight from '../Highlight/Highlight'

const PRODUCT_BASE_URL = 'https://monicaandandy.com/products/'

const Product = ({ product, query }) => {
    // console.log('product', product)
    let queryLower = query.toString().toLowerCase()

    let matchingVariant = product.variants.find(
        (variant) =>
            variant.title.toString().toLowerCase().indexOf(queryLower) > -1
    )

    if (product.title.includes('Double Ruffle')) {
        // console.log('matchingVariant', matchingVariant)
    }

    let title = product.title.split('_')[0]

    let handle

    if (product && product.handle) {
        handle = product.handle.split('_')[0]
        handle = handle.replace(/trunk-sale-/g, '')
        handle = handle.replace(/sale-/g, '')
        handle = handle.replace(/-1$/, '')
        handle = handle.replace(/-2$/, '')
        handle = handle.replace(/-3$/, '')
        handle = handle.replace(/-4$/, '')
        handle = handle.replace(/-5$/, '')
    }

    return (
        <li className="product" key={product.id}>
            {matchingVariant ? (
                <a
                    href={
                        PRODUCT_BASE_URL +
                        handle +
                        '?variant=' +
                        matchingVariant.id
                    }
                >
                    <div className="product-image">
                        {matchingVariant && matchingVariant.image ? (
                            <img
                                className="variant-img"
                                src={matchingVariant.image}
                                alt={title}
                                key={matchingVariant.id}
                            />
                        ) : (
                            <img
                                className="product-img"
                                src={
                                    product.images_info &&
                                    product.images_info.length
                                        ? product.images_info[0].src
                                        : ''
                                }
                                alt={title}
                                key={product.id}
                            />
                        )}
                    </div>
                </a>
            ) : (
                <div className="product-image">
                    <a href={PRODUCT_BASE_URL + handle}>
                        <img
                            className="product-img"
                            src={
                                product.images_info &&
                                product.images_info.length
                                    ? product.images_info[0].src
                                    : ''
                            }
                            alt={title}
                            key={product.id}
                        />
                    </a>
                </div>
            )}
            <div className="product-wrap">
                <h3 className="product-title">
                    {matchingVariant && matchingVariant.length > 0 ? (
                        <a
                            href={
                                PRODUCT_BASE_URL +
                                handle +
                                '?variant=' +
                                matchingVariant.id
                            }
                        >
                            <Highlight search={query}>{title}</Highlight>
                        </a>
                    ) : (
                        <a href={PRODUCT_BASE_URL + handle}>
                            <Highlight search={query}>{title}</Highlight>
                        </a>
                    )}
                </h3>
                <div className="product-price">
                    <span className="price">
                        {product?.price_max && (
                            <span>${product.price_max.toFixed(2)}</span>
                        )}
                    </span>
                </div>
            </div>
        </li>
    )
}

export default Product
